module.exports = __webpack_public_path__ + "static/assets/2ec1a89d837e88549951b2c649de8b10.svg";